import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { getCountryFlag } from './flag';

// SiteUp V2 (decisão 2026-08-10): telefone exibido como bandeira do país +
// número no formato nacional (DDD + telefone). A bandeira vem do country code
// do próprio E.164 — NUNCA de um país fixo: há clientes fora do Brasil.
// Sem parse possível (número inválido/incompleto), devolve o valor cru sem
// bandeira — dado errado à mostra é melhor que dado inventado.
export const formatPhoneDisplay = raw => {
  if (!raw) return '';
  const candidate = String(raw).trim();
  // WAHA/Chatwoot gravam E.164 com "+"; alguns caminhos legados gravam só
  // dígitos. Dígito puro ainda é E.164 — o "+" aqui não escolhe país nenhum.
  const normalized = candidate.startsWith('+')
    ? candidate
    : `+${candidate.replace(/\D/g, '')}`;
  const parsed = parsePhoneNumberFromString(normalized);
  if (!parsed || !parsed.country) return candidate;
  return `${getCountryFlag(parsed.country)} ${parsed.formatNational()}`;
};
